import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import AppSection from '@/pages/home/components/AppSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import IndexSection from '@/pages/home/components/IndexSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AboutSection from '@/pages/home/components/AboutSection';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <AppSection />
        <CommentsSection />
        <MediaSection />
        <TopicsSection />
        <RankingSection />
        <FaqSection />
        <CardsSection />
        <UpdatesSection />
        <CarouselSection />
        <FeaturesSection />
        <IndexSection />
        <ContactSection />
        <AboutSection />
      </main>

      <Footer />
    </div>
  );
}